String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};
var VM = function () {
    var self = this;
    self.validate = function () {

        // Clear observables
        self.content('');
        self.errors.removeAll();

        var validator = new Ajv({ allErrors: true, jsonPointers: true, schemaId: 'auto' });
        var jsonSourceMap = new jsonMap();

        // Show loading animation
        document.querySelector('.loading-validator').classList.add('d-block');

        // Check if appsettings input is not empty & valid
        if(self.input()) {
            try {
                self.jsonInput(JSON.parse(self.input()));
            } catch(e) {
                self.errors.push({ message: "JSON file is not valid !", position: {line: null, column: null} });
                self.showResult(true);
                scrollToResponse();
                return;
            }
        } else {
            self.errors.push({ message: "JSON file is empty !", position: {line: null, column: null} });
            self.showResult(true);
            scrollToResponse();
            return;
        }

        // Get the scheme from appsettings.json and pass it into the validate function
        fetch("https://raw.githubusercontent.com/SchemaStore/schemastore/master/src/schemas/json/appsettings.json")
        .then(response => response.json())
        .then(schema => {
            // Schema must contain the $id attribute
            schema['id'] = 'http://json-schema.org/draft-04/schema#';
            validateJSON(schema, self.jsonInput());
        });

        function validateJSON(schema, content) {
            var sourceMap = jsonSourceMap.stringify(content, null, 2);
            var jsonLines = sourceMap.json.split('\n');
            var theContent = JSON.parse(jsonLines.slice().join('\n'));
            var theSource = jsonLines.slice().join('\n');
            var valid = validator.validate(schema, theContent);

            if (!valid) {
                var theLines = jsonLines;
                validator.errors.forEach(function(error) {
                    errorPointer = sourceMap.pointers[error.dataPath];
                    errorToPush = {
                        message: validator.errorsText([ error ]),
                        position: {
                            line: errorPointer.value.line ? errorPointer.value.line + 1 : null,
                            column: errorPointer.value.column ? errorPointer.value.column : null
                        }
                    };
                    self.errors.push(errorToPush);

                    var errorObject = ko.utils.arrayFilter(validator.errors, function(item) {
                        return item.dataPath.toLowerCase() === error.dataPath.toLowerCase();
                    })[0];
                    var errorKey = errorObject.dataPath === "" ? errorObject.dataPath : errorObject.dataPath.split("/").pop();
                    var errorToFix = errorObject.message === "" ? errorObject.message : errorObject.message.replaceAll("\"", "");

                    theLines[errorPointer.value.line] = "<span class='fa fa-times-circle' style='color: #e6614f' title='"+ errorKey + ": " + escapeHtml(errorToFix) +"'></span>" + theLines[errorPointer.value.line];
                });
                theSource = theLines.slice().join('\n');
            }

            self.showResult(true);
            self.content(theSource);

            // Hljs
            document.querySelectorAll('pre code').forEach((block) => {
                hljs.highlightBlock(block);
            });
            document.querySelectorAll('code.hljs.linenumber').forEach((block) => {
                hljs.lineNumbersBlock(block);
            });

            scrollToResponse();
        }

        function scrollToResponse() {
            // Remove loading animation
            document.querySelector('.loading-validator').classList.remove('d-block');

            // Go to validated result
            const targetPosition = document.querySelector("#validator-response").getBoundingClientRect().top + window.scrollY - 76;
            window.scroll({ top: targetPosition, behavior: 'smooth' });
        }

        function escapeHtml(unsafe) {
            return unsafe
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }
    };
    self.input = ko.observable("");
    self.emptyInput = ko.pureComputed(function(){
        return self.input() === "";
    });
    self.jsonInput = ko.observable();
    self.showResult = ko.observable(false);
    self.content = ko.observable();
    self.errors = ko.observableArray();
    self.jumpToLine = function(line) {
        // data-line-number
        line = line - 1;
        let elem = document.querySelector("div[data-line-number='" + line + "']");
        if (elem) {
            const targetPosition = elem.getBoundingClientRect().top + window.scrollY - 50;
            window.scroll({ top: targetPosition, behavior: 'smooth' });
        }
    };
    self.status = ko.pureComputed(function () {
        if (self.errors() && self.errors().length > 0) return "Invalid";
        return "Valid";
    });
    self.icon = ko.pureComputed(function () {
        if (self.errors() && self.errors().length > 0) return "fa-times-circle";
        return "fa-check";
    });
    self.color = ko.pureComputed(function () {
        if (self.errors() && self.errors().length > 0) return "#e6614f";
        return "#0da58e";
    });

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });
};

document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);
});